import { render } from "./BankAccountBalanceSettingForm.vue?vue&type=template&id=3b505a33&scoped=true"
import script from "./BankAccountBalanceSettingForm.vue?vue&type=script&lang=js"
export * from "./BankAccountBalanceSettingForm.vue?vue&type=script&lang=js"

import "./BankAccountBalanceSettingForm.vue?vue&type=style&index=0&id=3b505a33&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b505a33"]])

export default __exports__